exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UserPopup-e729cbd1{font-size:15px;line-height:22px;width:202px;display:flex}.UserPopup-e729cbd1 .profileImg-bc9a4392{margin-right:15px;line-height:0}.UserPopup-e729cbd1 .profileImg-bc9a4392 img{height:50px;width:50px;border-radius:50%;box-shadow:1px 1px 4px 0 rgba(0,0,0,0.1)}.UserPopup-e729cbd1 .username-c8a3c862{font-weight:500;color:#424242;font-size:14px}.UserPopup-e729cbd1 .meta-5e68d68e{color:#757575;font-size:14px}.UserPopup-e729cbd1 .latlng-1720d53e{color:#757575;font-size:12px}\n", ""]);

// Exports
exports.locals = {
	"UserPopup": "UserPopup-e729cbd1",
	"profileImg": "profileImg-bc9a4392",
	"username": "username-c8a3c862",
	"meta": "meta-5e68d68e",
	"latlng": "latlng-1720d53e"
};